








































































































import { Component, Vue } from 'vue-property-decorator'
import copy from 'copy-to-clipboard'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { ErroNoHistorico, resumoDoErro } from '@/shareds/historico-de-erros'

/**
 * Reabre os erros que este navegador mostrou hoje.
 *
 * Existe porque o aviso de erro é um snackbar: o operador fecha sem ler, e o código do erro (que é
 * como o Suporte acha a ocorrência no banco em um SELECT) se perde. O botão copia só o código, que
 * é a única coisa que o Suporte precisa receber de volta: o resto da ficha já está no banco, ligado
 * a esse mesmo código.
 */
@Component
export default class DialogoDeHistoricoDeErros extends Vue {
	aberto = false
	stackVisivel: string | null = null

	get historico() {
		return AlertModule.historico
	}

	/**
	 * Limpar é regra de perfil, e nasce desmarcada em todo perfil.
	 *
	 * O histórico é a única cópia que o cliente tem do código do erro quando ele fechou o aviso sem
	 * ler. Apagar por engano custa a ocorrência exata, e é o operador na loja, com o erro na tela,
	 * que teria o impulso de "limpar essa lista de erros".
	 */
	get podeLimpar() {
		return !!UserLoginStore.permiteRegraDeNegocio('pode-limpar-historico-de-erros')
	}

	mostrar() {
		AlertModule.abrirHistorico()
		this.stackVisivel = null
		this.aberto = true
	}

	resumo = resumoDoErro

	alternarStack(id: string) {
		this.stackVisivel = this.stackVisivel === id ? null : id
	}

	copiar(erro: ErroNoHistorico) {
		if (!erro.codigo) return
		copy(erro.codigo)
		AlertModule.setSuccess('Código do erro copiado. Informe ao suporte.')
	}

	limpar() {
		AlertModule.limparHistorico()
	}

	hora(iso: string) {
		return new Date(iso).toLocaleTimeString('pt-BR')
	}

	dataHora(iso: string) {
		return new Date(iso).toLocaleString('pt-BR')
	}
}
